import * as eventTypes from './eventTypes'
import * as actionTypes from './actionTypes'

var events = {}

events[actionTypes.ENABLE_NOTIFICATION_CHANNEL_FINISH] = function (action) {
  if (action.error) {
    return {
      type: eventTypes.NOTI_ERROR,
      args: { channel: action.meta.channel, error: action.payload }
    }
  } else {
    return {
      type: eventTypes.NOTI_CHANGE,
      args: { channel: action.meta.channel }
    }
  }
}

events[actionTypes.NOTIFICATION_RECEIVED] = function (action) {
  if (!action.error) {
    return {
      type: eventTypes.NOTI_RECEIVED,
      args: { payload: action.payload }
    }
  }
}

export default events
